export const TYPE_INVOICE = 'INVOICE';
export const TYPE_BRAINTREE = 'BRAINTREE';
export const TYPE_PAYPAL = 'PAYPAL';
export const TYPE_UNKNOWN = 'UNKNOWN';
